import { ICMSApiResponse } from "../common/types";
import i18next from "i18next";

const buildValidatedUrl = (baseUrl: string): string => {
  try {
    if (baseUrl.includes('/../') || /\/%2e%2e\//i.test(baseUrl)) {
      throw new Error('Invalid path');
    }

    const url = new URL(baseUrl);

    if (!['http:', 'https:'].includes(url.protocol)) {
      throw new Error('Invalid protocol');
    }

    const base = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
    url.pathname = `${base}/api/v1/event.details.json`;

    return url.href;
  } catch {
    throw new Error('Invalid URL');
  }
};

const getCmsUrl = (domain: string) => buildValidatedUrl(domain);

const getApiResult = async (eventDomain: string) => {
  const primaryResponse = await fetch(getCmsUrl(eventDomain));
  return (await primaryResponse.json()) as unknown as ICMSApiResponse;
};

const isDefaultUrlPresent = (response: ICMSApiResponse) => {
  return (
    response.badges["en-gb"] &&
    response.badges["en-gb"].detailsPage &&
    response.badges["en-gb"].detailsPage.length &&
    response.badges["en-gb"].detailsPage[0].url
  );
};

const isRequestedUrlPresent = (requestBadgeLocationURLObject?: { [key: string]: Array<{ url: string }> }) => {
  return (
    requestBadgeLocationURLObject &&
    requestBadgeLocationURLObject.detailsPage &&
    requestBadgeLocationURLObject.detailsPage.length &&
    requestBadgeLocationURLObject.detailsPage.find(x => x.url)
  );
};

const getBadgeLocationUrl = async (eventUrl) => {
  const locale = i18next.language.toLowerCase();
  const response = await getApiResult(eventUrl);
  const requestBadgeLocationURLObject = response.badges[locale];
  let requestBadgeURL = "";

  if (isRequestedUrlPresent(requestBadgeLocationURLObject)) {
    requestBadgeURL = requestBadgeLocationURLObject!.detailsPage[0].url;
  } else if (isDefaultUrlPresent(response)) {
    requestBadgeURL = response.badges["en-gb"]!.detailsPage[0].url;
  }

  if (!requestBadgeURL) {
    Object.values(response.badges).some(x => {
      if (x.detailsPage && x.detailsPage.length && x.detailsPage[0].url) {
        requestBadgeURL = x.detailsPage[0].url;
        return true;
      }
      return false;
    });
  }
  return { url: requestBadgeURL, fullResponse: response };
};

const CMSApiService = {
  getBadgeLocationUrl
};

export default CMSApiService;
